
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember-decorators/utils/-embroider-implicit-modules.js";
